import React from 'react';
import {DateTimeFormat} from 'components/UI/DateTime';
import {getPrice} from 'lib/convert';

class OrderBox extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  // deprecated
  getPrice(value) {
    String.prototype.splice = function(idx, rem, str) {
      return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
    };
    let result = value;
    if(String(result).length < 3) {
      return result
    } else {
      for (let j = Number(String(result).length); j > 0;) {
        j = j - 3;
        if(j > 0) {
          result = String(result).splice(j, 0, ",");
        }
      }
      return result
    }
  }

  render() {
    return (

      <tbody>

        <tr>
          <td>{this.props.index}</td>
          <td>
            <p>Người mua hàng: {this.props.customerName}</p>
            <p>Số điện thoại: {this.props.customerPhone}</p>
          </td>
          <td>
            <DateTimeFormat value={this.props.createdAt}/>
          </td>
          <td>
            <span>{getPrice(this.props.amount)}</span>
          </td>
          <td>{this.props.actionPanel}</td>
        </tr>

      </tbody>


    );
  }
}

export default OrderBox;



// WEBPACK FOOTER //
// ./components/fair/fair-order/OrderBox.jsx